import { AxiosArgs, ThenArgs, Incident } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeQueryParams } from 'src/api/client';

type GetIncident = (id: string, query?: { version?: string }) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Incident>>>>;

export const getIncident: GetIncident = (id, query = {}) => {
  const path = `/api/public/api/incidents/${id}${encodeQueryParams(query)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
